import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'mobx-react';
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route
} from 'react-router-dom';
import HomeStore from './store/HomeStore';
import EditorStore from './store/EditorStore';
import HomePage from './containers/HomePage';
import EventsPage from './containers/EventsPage';
import TransformsPage from './containers/TransformsPage';
import EditorPage from './containers/EditorPage';

import 'normalize.css';
import './styles/app.scss';

const homeStore = new HomeStore();
const editorStore = new EditorStore();

const stores = {
  homeStore,
  editorStore
};

render(
  <Provider {...stores}>
    <Router>
      <Switch>
        <Route exact path='/product-gallery/editor' component={EditorPage}/>
        <Route exact path='/product-gallery/events' component={EventsPage}/>
        <Route exact path='/product-gallery/transform' component={TransformsPage}/>
        <Route exact path='/product-gallery' component={HomePage}/>
        <Route exact path='/editor' render={() => <Redirect to='/product-gallery/editor' />}/>
        <Route exact path='/' render={() => <Redirect to='/product-gallery' />}/>
      </Switch>
    </Router>
  </Provider>,
  document.getElementById('root'),
);
